/* You must register this file at "website\src\i18n\en-us" */

export default {
    /* Global Vocabulary */
    close: 'Close',
    send_more_get_better_rates: 'Send more, get better rates',

    /* Module special vocabulary */
    ramps: {
        menu: {
            index: 'Ramps',
            create: 'New ramp',
            list: 'Ramps'
        },
        table_titles: {
            id: 'ID',
            from_currency: 'From currency',
            on_ramp_operator: 'On-ramp operator',
            on_ramp_exchange: 'On-ramp exchange',
            on_ramp_margin: 'On-ramp margin',
            asset: 'Asset',
            off_ramp_operator: 'Off-ramp operator',
            off_ramp_exchange: 'Off-ramp exchange',
            off_ramp_margin: 'Off-ramp margin',
            to_currency: 'To currency',
            min_transfer_amount: 'Min transfer amount',
            max_transfer_amount: 'Max transfer amount',
            max_monthly_transfer: 'Monthly limit',
            annual_limit: 'Annual limit',
            welcome_reward: 'Welcome reward',
            service_fee: 'Service Fee',
            service_fee_threshold: 'Service Fee Threshold',
            decimals: 'Decimals',
            exchange_rate: 'Exchange rate',
            status: 'Status',
            permission: 'Permission',
            transfer_time: "Transfer time",
            setting: 'Edit / Delete',
        },
        tiers: {
            index: 'Tiers',
            create: 'New',
            edit: 'Edit a tier',
            table_titles: {
                id: 'ID',
                amount: 'Min Amount',
                customer_level: 'Customer level',
                on_ramp_discount: 'On-Ramp Discount',
                off_ramp_discount: 'Off-Ramp Discount',
                exchange_rate: 'Exchange rate',
                created_at: 'Created at',
                updated_at: 'Updated at',
                setting: 'Delete'
            }
        },
        edit: 'Edit a ramp',
        confirm: 'Confirm',
        remove: 'Remove',
    },
    transfer_limits: {
        id: 'ID',
        from: 'From',
        to: 'To',
        from_country: 'From country',
        to_country: 'To country',
        monthly_limit: 'Monthly limit',
        annual_limit: 'Annual limit',
    },
    calculator: {
        you_send: 'You send',
        recipient_gets: 'Recipient gets',
        service_fee: 'Service Fee',
        reward: 'Reward',
        rewards: 'Rewards',
        unusable_rewards: 'Unusable Rewards',
        welcome_reward: 'Welcome Reward',
        total_to_pay: 'Total to Pay',
        transfer_time: 'Transfer Time',
        offer: 'Offer',
        who_should_receive_this_offer: 'Who should receive this offer?',
        you_can_use_your_x_symbol_when_you_pay_in_symbol_only: 'You can use your {total} {symbol} when you pay in {symbol} only',
        the_minimum_order_size_to_redeem_the_reward_is_currency_symbol: 'The minimum order size to redeem the Reward is {x}.',
        i_pay_x_symbol_less: 'I pay {x} less',
        rebit_pays_x_more: 'Rebit pays {x} more',
        i_pay_n_fees_recipient_gets_x: 'I pay {origin} +fees, recipient gets {dest}',
        i_pay_n_fees_recipient_exactly_gets_x: 'I pay {origin} {plus_fees}, recipient exactly gets {dest}',
        plus_fees: '+fees',
        errors: {
            sending_amount_range: 'Sending amount should be between {min} and {max} {currency}.'
        },
        standard_rate: 'Standard Rate',
        above: 'Above',
        you_can_also_type_here: 'You can also type here.',
        select_currency_of_discount: 'Select currency of discount',
        transfer_time_disclaimer: '<p>Transfer times do not include the recipient\'s bank holidays. Transfers may also be delayed due to various factors, including but not limited to:</p>'
            + '<ul>'
            + '<li>The type of service selected</li>'
            + '<li>The amount sent</li>'
            + '<li>The destination country</li>'
            + '<li>Currency cash flow & availability</li>'
            + '<li>Legal and identification requirements</li>'
            + '<li>Customer protection issues</li>'
            + '<li>Delivery restrictions such as agent location hours and time zone differences</li>'
            + '</ul>'
            + '<p>For more details, please refer to our Terms and Conditions.</p>',
    }
}
